import {Component, OnInit} from '@angular/core';
import {LoginService} from './login.service';
import {Router} from '@angular/router';
import {StateStorageService} from '../../shared/auth/state-storage.service';
import {DataStorageService} from '../../shared/data-storage.service';
import {HttpErrorResponse} from '@angular/common/http';
import {ErrorClass} from '../../error/error-class';
import {NGXLogger} from 'ngx-logger';
import {PopUpService} from '../PopUpService';
import {SharedService} from '../shared.service';
import {LoaderService} from '../../loader/loader.service';
import {TranslateService} from '@ngx-translate/core';
import {Subscription} from 'rxjs';
import {EkpayUser} from '../../user/ekpay_user';
import {NgForm} from '@angular/forms';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  authenticationError: boolean;
  id_token: string;
  token: string;
  user: EkpayUser;
  username: String = '';
  password: String = '';
  errormessage = '';
  image: string;
  captcha = '';
  isCaptchaValid = false;
  subscription: Subscription;
  lang: string;
  show: boolean;
  hide: boolean;
  isCapcha: any;
  isCaptchaRequired: boolean;

  constructor(
    private loginService: LoginService,
    private stateStorageService: StateStorageService,
    private router: Router,
    private logger: NGXLogger,
    private popupservice: PopUpService,
    private sharedService: SharedService,
    private loaderService: LoaderService,
    private dataStorageService: DataStorageService,
    private readonly translate: TranslateService
  ) {
  }

  ngOnInit() {
    this.show = true;
    this.subscription = this.dataStorageService.langData$.subscribe((data) => {
      this.lang = data;
      if (this.lang == '' || this.lang == null) {
        this.lang = localStorage.getItem('lang');
      }
      this.translate.use(this.lang);
    });
    this.logger.debug('login component is called');
    this.sharedService.getCapcha().subscribe(data => {
      this.logger.debug('response....' + data);
      this.image = data;
    });
  }

  refreshCaptcha() {
    this.image = null;
    this.sharedService.getCapcha().subscribe(data => {
      this.logger.debug('response....' + data);
      this.image = data;
    });
  }

  public send(form: NgForm): void {
    if (form.invalid) {
      for (const control of Object.keys(form.controls)) {
        form.controls[control].markAsTouched();
      }
      return;
    }

    this.logger.debug(`Token [${this.token}] generated`);
  }

  public resolved(captchaResponse: string) {
    this.logger.debug(`Resolved captcha with response: ${captchaResponse}`);
    this.isCaptchaRequired = false;
    if (captchaResponse == null) {
      this.isCaptchaValid = false;
    } else {
      this.isCaptchaValid = true;
    }


  }


  login() {
    this.logger.debug('validate captcha....');
    this.loaderService.show();
    this.logger.debug('this.isCaptchaValid---------> ', this.isCaptchaValid);
    if (this.isCaptchaValid) {
      this.logger.debug('going to authenticate user -> ');
      this.user = new EkpayUser();
      this.loginService.login({
        username: this.username,
        password: this.password
      }).then((data) => {
        this.logger.debug('data before login..' + JSON.stringify(data));
        this.user = data as EkpayUser;
        this.logger.debug('data in login..' + JSON.stringify(this.user.default_lang));
        this.authenticationError = false;
        this.dataStorageService.setUserData(this.user);
        this.logger.debug('data in login 2..' + JSON.stringify(localStorage.getItem('lang')));
        if (this.user.default_lang != localStorage.getItem('lang')) {
          this.logger.debug('not equal change the lang');
          // this.translate.use(this.user.default_lang);
          localStorage.setItem('lang', this.user.default_lang);
          // this.dataStorageService.setLangData(localStorage.getItem("lang"));
        }
        this.logger.debug('data in login 3..' + JSON.stringify(localStorage.getItem('lang')));
        localStorage.setItem('sessuser', JSON.stringify(this.user));
        this.logger.debug('url... ' + this.router.url);
        this.popupservice.isLogin = false;
        if (this.router.url === '/register' || (/^\/activate\//.test(this.router.url)) ||
          (/^\/reset\//.test(this.router.url))) {
          this.router.navigate(['']);
        }

        const redirect = this.stateStorageService.getUrl();
        this.logger.debug('redirect...' + redirect);
        let redirectLink = redirect;
        if (redirect === null) {
          this.loaderService.hide();
          redirectLink = 'payment/app-login-page';
          // redirectLink = '';
          this.popupservice.isEnable = false;
          this.popupservice.isLogin = false;
          this.popupservice.isOtp = false;
          this.popupservice.isRegister = false;
        }
        this.logger.debug('redirectLink...' + redirectLink);
        if (redirectLink == null) {
          this.stateStorageService.storeUrl(null);
          this.router.navigate(['']);
        } else {
          this.stateStorageService.storeUrl(null);
          this.router.navigate([redirectLink]);
        }
      }).catch((err: HttpErrorResponse) => {
        this.logger.debug('err in login component...' + err);
        if (err.error instanceof Error) {
          this.logger.debug('An error occured in login component... ' + err.error);
        } else {
          this.logger.debug('Backend returned code ' + err.status + ',' + ' body was: ' + err.status);
        }
        this.logger.debug('error....' + JSON.stringify(err.error));
        this.loaderService.hide();
        this.authenticationError = true;
        this.dataStorageService.storage = new ErrorClass(err.name, err.status, err.message, '');
        this.popupservice.isEnable = false;
        // this.popupservice.isLogin = false;
        this.popupservice.isOtp = false;
        this.popupservice.isRegister = false;
        if (err.status == 401) {
          this.errormessage = err.error.AuthenticationException;
          this.refreshCaptcha();
        } else {
          this.popupservice.isLogin = false;
        }
      });
    } else {
      this.loaderService.hide();
      this.isCaptchaRequired = true;
    }

  }


  // login() {
  //   this.logger.debug('validate captcha....');
  //   this.isCaptchaValid = false;
  //   this.loaderService.show();
  //   this.sharedService.validateCapcha(this.captcha).subscribe(data => {
  //     this.logger.debug('response....' + JSON.stringify(data));
  //     if (data == 'success') {
  //       this.logger.debug('going to authenticate user -> ');
  //       this.user = new EkpayUser();
  //       this.loginService.login({
  //         username: this.username,
  //         password: this.password
  //       }).then((data) => {
  //         this.logger.debug('data before login..' + JSON.stringify(data));
  //         this.user = data as EkpayUser;
  //         this.logger.debug('data in login..' + JSON.stringify(this.user.default_lang));
  //         this.authenticationError = false;
  //         this.dataStorageService.setUserData(this.user);
  //         this.logger.debug('data in login 2..' + JSON.stringify(localStorage.getItem('lang')));
  //         if (this.user.default_lang != localStorage.getItem('lang')) {
  //           this.logger.debug('not equal change the lang');
  //           // this.translate.use(this.user.default_lang);
  //           localStorage.setItem('lang', this.user.default_lang);
  //           // this.dataStorageService.setLangData(localStorage.getItem("lang"));
  //         }
  //         this.logger.debug('data in login 3..' + JSON.stringify(localStorage.getItem('lang')));
  //         localStorage.setItem('sessuser', JSON.stringify(this.user));
  //         this.logger.debug('url... ' + this.router.url);
  //         this.popupservice.isLogin = false;
  //         if (this.router.url === '/register' || (/^\/activate\//.test(this.router.url)) ||
  //           (/^\/reset\//.test(this.router.url))) {
  //           this.router.navigate(['']);
  //         }
  //
  //         const redirect = this.stateStorageService.getUrl();
  //         this.logger.debug('redirect...' + redirect);
  //         let redirectLink = redirect;
  //         if (redirect === null) {
  //           this.loaderService.hide();
  //           redirectLink = 'payment/app-login-page';
  //           // redirectLink = '';
  //           this.popupservice.isEnable = false;
  //           this.popupservice.isLogin = false;
  //           this.popupservice.isOtp = false;
  //           this.popupservice.isRegister = false;
  //         }
  //         this.logger.debug('redirectLink...' + redirectLink);
  //         if (redirectLink == null) {
  //           this.stateStorageService.storeUrl(null);
  //           this.router.navigate(['']);
  //         } else {
  //           this.stateStorageService.storeUrl(null);
  //           this.router.navigate([redirectLink]);
  //         }
  //       }).catch((err: HttpErrorResponse) => {
  //         this.logger.debug('err in login component...' + err);
  //         if (err.error instanceof Error) {
  //           this.logger.debug('An error occured in login component... ' + err.error);
  //         } else {
  //           this.logger.debug('Backend returned code ' + err.status + ',' + ' body was: ' + err.status);
  //         }
  //         this.logger.debug('error....' + JSON.stringify(err.error));
  //         this.loaderService.hide();
  //         this.authenticationError = true;
  //         this.dataStorageService.storage = new ErrorClass(err.name, err.status, err.message, '');
  //         this.popupservice.isEnable = false;
  //         // this.popupservice.isLogin = false;
  //         this.popupservice.isOtp = false;
  //         this.popupservice.isRegister = false;
  //         if (err.status == 401) {
  //           this.errormessage = err.error.AuthenticationException;
  //           this.refreshCaptcha();
  //         } else {
  //           this.popupservice.isLogin = false;
  //         }
  //       });
  //     } else {
  //       this.loaderService.hide();
  //       this.isCaptchaValid = true;
  //     }
  //   });
  //
  //
  // }

  forgotPassword() {
    this.popupservice.isEnable = false;
    this.popupservice.isLogin = false;
    this.popupservice.isOtp = false;
    this.popupservice.isRegister = false;
    this.popupservice.isForgot = true;
  }

  loginWithOtp() {
    this.popupservice.isLoginOtp = true;
    this.popupservice.isLogin = false;
    this.popupservice.isForgot = false;
    this.popupservice.isRegister = false;
  }

  logincloseUp() {
    this.popupservice.isLogin = false;
  }

  showPassword(input: any): any {
    input.type = input.type === 'password' ? 'text' : 'password';
    this.hide = true;
    this.show = false;
  }

  hidePassword(input: any): any {
    input.type = input.type === 'password' ? 'text' : 'password';
    this.hide = false;
    this.show = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/login/login.component.ts